// extracted by mini-css-extract-plugin
export default {"contents":"pF-z","sectionHeading":"qF-z"};